<template>
  <div class="h-100">
    <div v-if="refunds.length > 0">
      <div class="pb-9">
        <div class="mb-4 sticky-on--header">
          <div class="form-group form-group--search">
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.5 12.3125L11.3906 10.2188C11.7865 9.69792 12.0938 9.125 12.3125 8.5C12.5417 7.86458 12.6562 7.19792 12.6562 6.5C12.6562 5.64583 12.4948 4.84375 12.1719 4.09375C11.849 3.34375 11.4062 2.69271 10.8438 2.14062C10.2917 1.57812 9.64062 1.13542 8.89062 0.8125C8.14062 0.489583 7.34375 0.328125 6.5 0.328125C5.64583 0.328125 4.84375 0.489583 4.09375 0.8125C3.34375 1.13542 2.6875 1.57812 2.125 2.14062C1.57292 2.69271 1.13542 3.34375 0.8125 4.09375C0.489583 4.84375 0.328125 5.64583 0.328125 6.5C0.328125 7.34375 0.489583 8.14062 0.8125 8.89062C1.13542 9.64062 1.57292 10.2969 2.125 10.8594C2.6875 11.4115 3.34375 11.849 4.09375 12.1719C4.84375 12.4948 5.64583 12.6562 6.5 12.6562C7.19792 12.6562 7.85938 12.5469 8.48438 12.3281C9.11979 12.099 9.69792 11.7865 10.2188 11.3906L12.3281 13.5C12.4115 13.5833 12.5 13.6458 12.5938 13.6875C12.6979 13.7292 12.8021 13.75 12.9062 13.75C13.0208 13.75 13.125 13.7292 13.2188 13.6875C13.3229 13.6458 13.4167 13.5833 13.5 13.5C13.6667 13.3333 13.75 13.1354 13.75 12.9062C13.75 12.6771 13.6667 12.4792 13.5 12.3125ZM2 6.5C2 5.875 2.11979 5.29167 2.35938 4.75C2.58854 4.19792 2.90625 3.71875 3.3125 3.3125C3.71875 2.90625 4.19792 2.58854 4.75 2.35938C5.29167 2.11979 5.875 2 6.5 2C7.11458 2 7.69271 2.11979 8.23438 2.35938C8.78646 2.58854 9.26562 2.90625 9.67188 3.3125C10.0781 3.71875 10.401 4.19792 10.6406 4.75C10.8698 5.29167 10.9844 5.875 10.9844 6.5C10.9844 7.11458 10.8646 7.69271 10.625 8.23438C10.3958 8.77604 10.0833 9.25 9.6875 9.65625C9.6875 9.65625 9.68229 9.66146 9.67188 9.67188C9.67188 9.67188 9.66667 9.67188 9.65625 9.67188C9.65625 9.67188 9.65625 9.67708 9.65625 9.6875C9.25 10.0833 8.77604 10.401 8.23438 10.6406C7.69271 10.8698 7.11458 10.9844 6.5 10.9844C5.875 10.9844 5.29167 10.8646 4.75 10.625C4.19792 10.3958 3.71875 10.0781 3.3125 9.67188C2.90625 9.26562 2.58854 8.78646 2.35938 8.23438C2.11979 7.69271 2 7.11458 2 6.5Z"
                fill="#EA1D2C"
              />
            </svg>
            <input
              class="form-control"
              id="nf-number"
              type="text"
              v-model="filter.number"
              v-on:keyup.enter="filterInvocesText()"
              placeholder="Buscar número da nota fiscal"
            />
          </div>
        </div>
        <h6>Última solicitação</h6>
        <div class="box box--data box--data--has-icon">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.99 0C4.48 0 0 4.48 0 9.99C0 15.5 4.48 19.98 9.99 19.98C15.5 19.98 19.98 15.5 19.98 9.99C19.98 4.48 15.49 0 9.99 0ZM13.99 11.73H8.99C8.58 11.73 8.24 11.39 8.24 10.98V5.8C8.24 5.39 8.58 5.05 8.99 5.05C9.4 5.05 9.74 5.38 9.74 5.8V10.23H13.99C14.4 10.23 14.74 10.57 14.74 10.98C14.74 11.39 14.4 11.73 13.99 11.73Z"
              fill="#E7A74E"
            />
          </svg>
          <div v-if="getLastRequest.items && getLastRequest.items[0].user_input">
            <h6>Solicitação nº {{ getLastRequest.items[0].sequence }}</h6>
            <p>
              Valor R$
              {{
                calculateTotal(getLastRequest.items[0].user_input.products) | toCurrency
              }}
              <br />
              Data da compra:
              {{ getLastRequest.items[0].user_input.purchaseDate | moment("DD/MM/YYYY") }}
              <br />
              Solicitado Em:
              {{ getLastRequest.items[0].createdAt | moment("DD/MM/YYYY") }}
            </p>

            <b-badge
              :class="{
                'badge-success': getLastRequest.items[0].status === 'success',
                'badge-warning': getLastRequest.items[0].status === 'hold',
                'badge-info': getLastRequest.items[0].status === 'invalid',
              }"
            >
              {{ getStatus(getLastRequest.items[0].status) }}</b-badge
            >
          </div>
        </div>
        <hr />
        <h6 class="d-flex align-items-center justify-content-between">
          <span>Todas solicitações</span>

          <div
            class="filter"
            :class="{ selected: filter.filterSelected.length > 0 }"
            @click.prevent="openFilters()"
          >
            <span v-if="filter.filterSelected.length <= 0">Filtrar</span>

            <span v-else>{{ filterSelectedName }}</span>

            <svg
              v-if="filter.filterSelected.length <= 0"
              width="13"
              height="10"
              viewBox="0 0 13 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.697632 0.75C0.697632 0.335786 1.03342 0 1.44763 0H12.0872C12.5014 0 12.8372 0.335786 12.8372 0.75C12.8372 1.16421 12.5014 1.5 12.0872 1.5H1.44763C1.03342 1.5 0.697632 1.16421 0.697632 0.75ZM0.697632 4.75C0.697632 4.33579 1.03342 4 1.44763 4H9.05228C9.4665 4 9.80228 4.33579 9.80228 4.75C9.80228 5.16421 9.4665 5.5 9.05228 5.5H1.44763C1.03342 5.5 0.697632 5.16421 0.697632 4.75ZM1.44763 8C1.03342 8 0.697632 8.33579 0.697632 8.75C0.697632 9.16421 1.03342 9.5 1.44763 9.5H7.02903C7.44324 9.5 7.77903 9.16421 7.77903 8.75C7.77903 8.33579 7.44324 8 7.02903 8H1.44763Z"
                fill="#717171"
              />
            </svg>
            <svg
              v-else
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="16"
                y="16"
                width="16"
                height="16"
                transform="rotate(-180 16 16)"
                fill="#D8D8D8"
                fill-opacity="0.01"
              />
              <path
                d="M4.53033 5.46967C4.23744 5.17678 3.76256 5.17678 3.46967 5.46967C3.17678 5.76256 3.17678 6.23744 3.46967 6.53033L4.53033 5.46967ZM8 10L7.46967 10.5303L8 11.0607L8.53033 10.5303L8 10ZM12.5303 6.53033C12.8232 6.23744 12.8232 5.76256 12.5303 5.46967C12.2374 5.17678 11.7626 5.17678 11.4697 5.46967L12.5303 6.53033ZM3.46967 6.53033L7.46967 10.5303L8.53033 9.46967L4.53033 5.46967L3.46967 6.53033ZM8.53033 10.5303L12.5303 6.53033L11.4697 5.46967L7.46967 9.46967L8.53033 10.5303Z"
                fill="#EA1D2C"
              />
            </svg>
          </div>
        </h6>

        <div v-for="(invoice, key) in getInvoice.items" :key="key">
          <div class="box box--data box--data--has-icon" v-if="invoice.user_input">
            <svg
              v-if="invoice.status === 'success'"
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_355_4360)">
                <circle cx="10.8813" cy="10" r="10" fill="#50A773" />
                <path
                  d="M15.0761 7.18611L9.06766 13.1945L6.38136 10.4999"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_355_4360">
                  <rect
                    width="19.97"
                    height="19.97"
                    fill="white"
                    transform="translate(0.881348)"
                  />
                </clipPath>
              </defs>
            </svg>

            <svg
              v-if="invoice.status === 'hold'"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.99 0C4.48 0 0 4.48 0 9.99C0 15.5 4.48 19.98 9.99 19.98C15.5 19.98 19.98 15.5 19.98 9.99C19.98 4.48 15.49 0 9.99 0ZM13.99 11.73H8.99C8.58 11.73 8.24 11.39 8.24 10.98V5.8C8.24 5.39 8.58 5.05 8.99 5.05C9.4 5.05 9.74 5.38 9.74 5.8V10.23H13.99C14.4 10.23 14.74 10.57 14.74 10.98C14.74 11.39 14.4 11.73 13.99 11.73Z"
                fill="#E7A74E"
              />
            </svg>

            <!--Dia1<svg
              v-if="invoice.status === 'invalid'"
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_355_4472)">
                <circle cx="10.8813" cy="10" r="10" fill="#83166F" />
                <path
                  d="M14.2453 7L7.88134 13.364"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.88135 7L14.2453 13.364"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_355_4472">
                  <rect
                    width="19.97"
                    height="19.97"
                    fill="white"
                    transform="translate(0.881348)"
                  />
                </clipPath>
              </defs>
            </svg>-->

            <div v-if="invoice.user_input">
              <h6>Solicitação nº {{ invoice.sequence }}</h6>
              <p>
                Valor R$ {{ calculateTotal(invoice.user_input.products) | toCurrency }}
                <br />
                Data Compra: {{ invoice.user_input.purchaseDate | moment("DD/MM/YYYY") }}
                <br />
                Solicitado Em: {{ invoice.createdAt | moment("DD/MM/YYYY") }}
              </p>
              <!-- 'success' : invoice.status === 'success', 'info' : invoice.status === 'hold', 'warning' : invoice.status === 'invalid' -->
              <b-badge
                :class="{
                  'badge-success': invoice.status === 'success',
                  'badge-warning': invoice.status === 'hold',
                  //'badge-warning': invoice.status === 'invalid',
                  'badge-info': invoice.status === 'invalid',
                }"
                >{{ getStatus(invoice.status)  }} - {{invoice.reason}}</b-badge
              >
            </div>
          </div>
        </div>

        <div
          class="text-center mt-5 px-3"
          v-if="getInvoice.items && getInvoice.items.length <= 0"
        >
          <h5>Nenhum resultado</h5>
          <p>
            Nenhum resultado com o filtro <strong>{{ filterSelectedName }}</strong
            >.
          </p>
        </div>

        <!-- <div class="box box--data box--data--has-icon">
					<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g clip-path="url(#clip0_355_4360)">
							<circle cx="10.8813" cy="10" r="10" fill="#50A773" />
							<path d="M15.0761 7.18611L9.06766 13.1945L6.38136 10.4999" stroke="white" stroke-width="1.5"
								stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
						</g>
						<defs>
							<clipPath id="clip0_355_4360">
								<rect width="19.97" height="19.97" fill="white" transform="translate(0.881348)" />
							</clipPath>
						</defs>
					</svg>
					<div>
						<h6>Solicitação nº 131121939</h6>
						<p>
							Valor R$ 100,00 <br>
							Data: 12/09/2021
						</p>
						<b-badge variant="success">Aprovado</b-badge>
					</div>
				</div>

				<div class="box box--data box--data--has-icon">
					<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g clip-path="url(#clip0_355_4472)">
							<circle cx="10.8813" cy="10" r="10" fill="#83166F" />
							<path d="M14.2453 7L7.88134 13.364" stroke="white" stroke-width="1.5" stroke-miterlimit="10"
								stroke-linecap="round" stroke-linejoin="round" />
							<path d="M7.88135 7L14.2453 13.364" stroke="white" stroke-width="1.5" stroke-miterlimit="10"
								stroke-linecap="round" stroke-linejoin="round" />
						</g>
						<defs>
							<clipPath id="clip0_355_4472">
								<rect width="19.97" height="19.97" fill="white" transform="translate(0.881348)" />
							</clipPath>
						</defs>
					</svg>
					<div>
						<h6>Solicitação nº 131121939</h6>
						<p>
							Valor R$ 100,00 <br>
							Data: 12/09/2021
						</p>
						<b-badge variant="info">Não aprovado</b-badge>
					</div>
				</div>

				<div class="box box--data box--data--has-icon">
					<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M9.99 0C4.48 0 0 4.48 0 9.99C0 15.5 4.48 19.98 9.99 19.98C15.5 19.98 19.98 15.5 19.98 9.99C19.98 4.48 15.49 0 9.99 0ZM13.99 11.73H8.99C8.58 11.73 8.24 11.39 8.24 10.98V5.8C8.24 5.39 8.58 5.05 8.99 5.05C9.4 5.05 9.74 5.38 9.74 5.8V10.23H13.99C14.4 10.23 14.74 10.57 14.74 10.98C14.74 11.39 14.4 11.73 13.99 11.73Z"
							fill="#E7A74E" />
					</svg>
					<div>
						<h6>Solicitação nº 131121939</h6>
						<p>
							Valor R$ 100,00 <br>
							Data: 12/09/2021
						</p>
						<b-badge variant="warning">Em análise</b-badge>
					</div>
				</div> -->

        <bottom-sheet ref="myBottomSheet">
          <div class="container mb-4 filter-wrap">
            <h5 class="text-center mb-5">Filtrar por</h5>
            <div class="row mb-3">
              <div class="col text-center">
                <div
                  class="filter-btn"
                  @click="selectedBottomSheet = 'success'"
                  :class="{ selected: selectedBottomSheet === 'success' }"
                >
                  <svg
                    width="19"
                    height="14"
                    viewBox="0 0 19 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.9922 0.5C18.2579 0.78125 18.3907 1.11719 18.3907 1.50781C18.3907 1.88281 18.2579 2.21094 17.9922 2.49219L7.37506 13.0859C6.98444 13.4922 6.50006 13.6797 5.92194 13.6484C5.35944 13.6172 4.90631 13.3828 4.56256 12.9453L0.906311 8.375C0.671936 8.07812 0.570374 7.73438 0.601624 7.34375C0.648499 6.95312 0.828186 6.64062 1.14069 6.40625C1.43756 6.17188 1.7735 6.07812 2.1485 6.125C2.53912 6.15625 2.85944 6.32031 3.10944 6.61719L6.10944 10.4141L16.0001 0.5C16.2813 0.234375 16.6094 0.101562 16.9844 0.101562C17.3751 0.101562 17.711 0.234375 17.9922 0.5Z"
                    />
                  </svg>
                </div>
                Aprovados
              </div>
              <div class="col text-center">
                <div
                  class="filter-btn"
                  @click="selectedBottomSheet = 'hold'"
                  :class="{ selected: selectedBottomSheet === 'hold' }"
                >
                  <svg
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.992371 10.5C0.992371 9.10938 1.258 7.8125 1.78925 6.60938C2.30487 5.39062 3.01581 4.32812 3.92206 3.42188C4.82831 2.51563 5.883 1.80469 7.08612 1.28906C8.30487 0.757813 9.60175 0.492188 10.9767 0.492188C12.3674 0.492188 13.6642 0.757813 14.8674 1.28906C16.0861 1.80469 17.1408 2.51563 18.0314 3.42188C18.9377 4.32812 19.6564 5.39062 20.1877 6.60938C20.7033 7.8125 20.9611 9.10938 20.9611 10.5C20.9611 10.7031 20.8908 10.8828 20.7502 11.0391C20.6096 11.1797 20.4299 11.25 20.2111 11.25C20.008 11.25 19.8283 11.1797 19.6721 11.0391C19.5314 10.8828 19.4611 10.7031 19.4611 10.5C19.4611 9.32812 19.2424 8.22656 18.8049 7.19531C18.3674 6.16406 17.758 5.26562 16.9767 4.5C16.2111 3.71875 15.3127 3.10937 14.2814 2.67188C13.2502 2.21875 12.1486 1.99219 10.9767 1.99219C9.80487 1.99219 8.70331 2.21875 7.67206 2.67188C6.64081 3.10937 5.74237 3.71094 4.97675 4.47656C4.21112 5.24219 3.60956 6.14062 3.17206 7.17188C2.71893 8.20312 2.49237 9.3125 2.49237 10.5C2.49237 11.6719 2.71893 12.7734 3.17206 13.8047C3.60956 14.8359 4.21112 15.7344 4.97675 16.5C5.74237 17.2656 6.64081 17.8672 7.67206 18.3047C8.70331 18.7578 9.81268 18.9844 11.0002 18.9844C11.6721 18.9844 12.3283 18.9062 12.9689 18.75C13.6096 18.5938 14.2111 18.375 14.7736 18.0938C15.3361 17.8125 15.8674 17.4688 16.3674 17.0625C16.8517 16.6562 17.2892 16.2109 17.6799 15.7266C17.8049 15.5547 17.9689 15.4609 18.1721 15.4453C18.3752 15.4141 18.5627 15.4609 18.7346 15.5859C18.8908 15.7109 18.9846 15.8828 19.0158 16.1016C19.0471 16.3047 18.9924 16.4844 18.8517 16.6406C18.3986 17.2188 17.883 17.75 17.3049 18.2344C16.7267 18.7031 16.1017 19.1094 15.4299 19.4531C14.7736 19.7812 14.0705 20.0312 13.3205 20.2031C12.5705 20.3906 11.7971 20.4844 11.0002 20.4844C9.60956 20.4844 8.31268 20.2188 7.10956 19.6875C5.89081 19.1719 4.82831 18.4609 3.92206 17.5547C3.01581 16.6484 2.30487 15.5938 1.78925 14.3906C1.258 13.1719 0.992371 11.875 0.992371 10.5ZM9.99237 5.55469C10.1955 5.55469 10.3674 5.63281 10.508 5.78906C10.6642 5.92969 10.7424 6.10156 10.7424 6.30469V10.7344H14.9846C15.1877 10.7344 15.3596 10.8125 15.5002 10.9688C15.6564 11.1094 15.7346 11.2812 15.7346 11.4844C15.7346 11.6875 15.6564 11.8672 15.5002 12.0234C15.3596 12.1641 15.1877 12.2344 14.9846 12.2344H9.99237C9.78925 12.2344 9.60956 12.1641 9.45331 12.0234C9.31268 11.8672 9.24237 11.6875 9.24237 11.4844V6.30469C9.24237 6.10156 9.31268 5.92969 9.45331 5.78906C9.60956 5.63281 9.78925 5.55469 9.99237 5.55469Z"
                    />
                  </svg>
                </div>
                Em análise
              </div>
              <div class="col text-center">
                <div
                  class="filter-btn"
                  @click="selectedBottomSheet = 'invalid'"
                  :class="{ selected: selectedBottomSheet === 'invalid' }"
                >
                  <svg
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.05481 7.5L13.3751 2.20312C13.5157 2.04688 13.5861 1.86719 13.5861 1.66406C13.5861 1.46094 13.5157 1.28125 13.3751 1.125C13.2189 0.984375 13.0392 0.914062 12.8361 0.914062C12.6329 0.914062 12.4532 0.984375 12.297 1.125L7.00012 6.44531L1.70325 1.125C1.56262 0.984375 1.38293 0.914062 1.16418 0.914062C0.96106 0.914062 0.789185 0.984375 0.64856 1.125C0.507935 1.28125 0.437622 1.46094 0.437622 1.66406C0.437622 1.86719 0.507935 2.04688 0.64856 2.20312L5.94543 7.5L0.64856 12.7969C0.507935 12.9375 0.437622 13.1172 0.437622 13.3359C0.437622 13.5391 0.507935 13.7109 0.64856 13.8516C0.726685 13.9297 0.80481 13.9922 0.882935 14.0391C0.976685 14.0703 1.07043 14.0859 1.16418 14.0859C1.27356 14.0859 1.36731 14.0703 1.44543 14.0391C1.53918 13.9922 1.62512 13.9297 1.70325 13.8516L7.00012 8.55469L12.297 13.8516C12.3751 13.9297 12.4611 13.9922 12.5548 14.0391C12.6486 14.0703 12.7423 14.0859 12.8361 14.0859C12.9298 14.0859 13.0236 14.0703 13.1173 14.0391C13.2111 13.9922 13.297 13.9297 13.3751 13.8516C13.5157 13.7109 13.5861 13.5391 13.5861 13.3359C13.5861 13.1172 13.5157 12.9375 13.3751 12.7969L8.05481 7.5Z"
                    />
                  </svg>
                </div>
                Não aprovados
              </div>
            </div>
            <button
              @click="chooseFilter(selectedBottomSheet)"
              type="button"
              class="btn btn-primary btn-lg btn-block"
            >
              Ver resultados 
            </button>
          </div>
        </bottom-sheet>
      </div>
      <!--<ifood-footer class="p-3" style="background-color: #fff">
        <router-link
          :to="{ name: 'NewRefundWarning' }"
          class="btn btn-primary btn-lg btn-block"
          >Criar nova solicitação
        </router-link>
      </ifood-footer>
      -->
    </div>
    <div v-else class="d-flex align-items-center h-100 text-center px-3">
      <div>
        <img
          src="../assets/svg/motoboy-01.svg"
          style="max-width: 100%; max-height: 255px"
          class="mb-3"
        />
        <h5>Você não tem solicitações</h5>
        <p>Você ainda não fez nenhuma solicitação de reembolso.</p>
      </div>
      <!--<ifood-footer class="p-3" style="background-color: #fff">
        <router-link
          :to="{ name: 'NewRefundWarning' }"
          class="btn btn-primary btn-lg btn-block"
          >Criar nova solicitação
        </router-link>
      </ifood-footer>-->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ifoodFooter from "@/components/Footer.vue";
import bottomSheet from "@/components/bottomSheet.vue";

import amplitude from "amplitude-js";
import Faster, { FasterConfiguration } from "faster-sdk-js";
import { EventBuilder } from "faster-sdk-js";
export default {
  name: "Rules",
  directives: {},
  components: {
    ifoodFooter,
    bottomSheet,
  },
  data() {
    return {
      filter: {
        filterSelected: "",
        number: "",
        user:  localStorage.getItem("id")
      },
      selectedBottomSheet: "",
      // filterSelected: "",
      refunds: [{}],
    };
  },
  watch: {},
  methods: {
    ...mapActions({
      consultRefund: "consultRefund",
      consultLastRefund: "consultLastRefund",
    }),
    openFilters() {
      const configuration = new FasterConfiguration(
        "c352c9f1-6120-4ef5-87e3-c5cec5eb1cda",
        "oIwfANqzIAItf97FHJulmwvN"
      );
      Faster.configure(configuration);
      const fasterAnalyticsInstance = Faster.start();
      const eventBuilder = new EventBuilder("Print_Covidrefund_Filter", 0);
      const event_faster = eventBuilder
        .id(localStorage.getItem("id"))
        .externalId(localStorage.getItem("worker_id"))
        .dimension("driverId", localStorage.getItem("worker_id"))
        .build();
      fasterAnalyticsInstance.event.register(event_faster);
      //End
      //amplitude
      var userId = localStorage.getItem("worker_id");
      amplitude.getInstance().init("acd3720cc16f656e0f48bf417916784d", userId);
      var event = "Print_Covidrefund_Filter";
      var eventProperties = {
        driver_Id: localStorage.getItem("worker_id"),
        driver_uuid: localStorage.getItem("id"),
        timestamp: Date.now(),
      };
      amplitude.getInstance().logEvent(event, eventProperties);

      this.$refs.myBottomSheet.open();
    },
    chooseFilter(filter) {
      const configuration = new FasterConfiguration(
        "c352c9f1-6120-4ef5-87e3-c5cec5eb1cda",
        "oIwfANqzIAItf97FHJulmwvN"
      );
      Faster.configure(configuration);
      const fasterAnalyticsInstance = Faster.start();
      const eventBuilder = new EventBuilder("Click_Covidrefund_Filter_SeeResults", 0);
      const event_faster = eventBuilder
        .id(localStorage.getItem("id"))
        .externalId(localStorage.getItem("worker_id"))
        .dimension("driverId", localStorage.getItem("worker_id"))
        .dimension("filterSelected", filter)
        .build();
      fasterAnalyticsInstance.event.register(event_faster);
      //End
      //amplitude
      var userId = localStorage.getItem("worker_id");
      amplitude.getInstance().init("acd3720cc16f656e0f48bf417916784d", userId);
      var event = "Click_Covidrefund_Filter_SeeResults";
      var eventProperties = {
        driver_Id: localStorage.getItem("worker_id"),
        driver_uuid: localStorage.getItem("id"),
        dimension: filter,
        timestamp: Date.now(),
      };
      amplitude.getInstance().logEvent(event, eventProperties);

      this.filter.filterSelected = filter;
      this.$refs.myBottomSheet.close();
      this.filterInvoces();
    },
    async filterInvocesText() {
      const configuration = new FasterConfiguration(
        "c352c9f1-6120-4ef5-87e3-c5cec5eb1cda",
        "oIwfANqzIAItf97FHJulmwvN"
      );
      Faster.configure(configuration);
      const fasterAnalyticsInstance = Faster.start();
      const eventBuilder = new EventBuilder("Click_CovidRefund_ReceiptSearch", 0);
      const event_faster = eventBuilder
        .id(localStorage.getItem("id"))
        .externalId(localStorage.getItem("worker_id"))
        .dimension("driverId", localStorage.getItem("worker_id"))
        .build();
      fasterAnalyticsInstance.event.register(event_faster);
      //End
      //amplitude
      var userId = localStorage.getItem("worker_id");
      amplitude.getInstance().init("acd3720cc16f656e0f48bf417916784d", userId);
      var event = "Click_CovidRefund_ReceiptSearch";
      var eventProperties = {
        driver_Id: localStorage.getItem("worker_id"),
        driver_uuid: localStorage.getItem("id"),
        timestamp: Date.now(),
      };
      amplitude.getInstance().logEvent(event, eventProperties);

      let loader = this.$loading.show();
      try {
        await this.consultRefund(this.filter);
        loader.hide();
      } catch (error) {
        console.log(error);
        loader.hide();
      }
    },
    async filterInvoces() {
      this.$refs.myBottomSheet.close();
      this.consultRefund(this.filter);
    },
    async filterInvocesText() {
      const configuration = new FasterConfiguration(
        "c352c9f1-6120-4ef5-87e3-c5cec5eb1cda",
        "oIwfANqzIAItf97FHJulmwvN"
      );
      Faster.configure(configuration);
      const fasterAnalyticsInstance = Faster.start();
      const eventBuilder = new EventBuilder("Click_CovidRefund_ReceiptSearch", 0);
      const event_faster = eventBuilder
        .id(localStorage.getItem("id"))
        .externalId(localStorage.getItem("worker_id"))
        .dimension("driverId", localStorage.getItem("worker_id"))
        .build();
      fasterAnalyticsInstance.event.register(event_faster);
      //End
      //amplitude
      var userId = localStorage.getItem("worker_id");
      amplitude.getInstance().init("acd3720cc16f656e0f48bf417916784d", userId);
      var event = "Click_CovidRefund_ReceiptSearch";
      var eventProperties = {
        driver_Id: localStorage.getItem("worker_id"),
        driver_uuid: localStorage.getItem("id"),
        timestamp: Date.now(),
      };
      amplitude.getInstance().logEvent(event, eventProperties);

      let loader = this.$loading.show();
      try {
        await this.consultRefund(this.filter);
        loader.hide();
      } catch (error) {
        console.log(error);
        loader.hide();
      }
    },
    calculateTotal(products) {
      let productsTotal;
      let quantityTotal = 0;
      products.forEach((product) => {
        // console.log("TOTAL VALUE", product.value * product.quantity);
        let productsTotal = product.value * product.quantity;
        //console.log(productsTotal);
        quantityTotal = productsTotal + quantityTotal;
      });
      // ======================================
      //if (quantityTotal != NaN) console.log("NAN");
      //else console.log("NOT NAN");
      // ======================================
      if (quantityTotal != NaN) return quantityTotal;
      else return "00,00";
    },
    getStatus(status) {
      switch (status) {
        case "hold":
          return "Em Analise";
        case "success":
          return "successo";
        case "paid":
          return "Pago";
        case "invalid":
          return "Não Aprovado";
      }
    },
  },
  computed: {
    ...mapGetters({
      getInvoice: "getInvoice",
      getLastRequest: "getLastRequest",
    }),
    filterSelectedName() {
      switch (this.filter.filterSelected) {
        case "hold":
          return "Em Análise";
        case "success":
          return "Aprovados";
        case "invalid":
          return "Não aprovados";
        default:
          return "Filtrar";
      }
    },
  },
  async mounted() {
    let loader = this.$loading.show();
    try {
      await this.consultLastRefund({ user:  localStorage.getItem("id")});
      await this.consultRefund(this.filter);
      loader.hide();
      console.log(this.refunds);
      if (this.refunds) {
        if (this.refunds.length) {
          const configuration = new FasterConfiguration(
            "c352c9f1-6120-4ef5-87e3-c5cec5eb1cda",
            "oIwfANqzIAItf97FHJulmwvN"
          );
          Faster.configure(configuration);
          const fasterAnalyticsInstance = Faster.start();
          const eventBuilder = new EventBuilder("View_CovidRefund_Home", 0);
          const event_faster = eventBuilder
            .id(localStorage.getItem("id"))
            .externalId(localStorage.getItem("worker_id"))
            .dimension("driverId", localStorage.getItem("worker_id"))
            .dimension("source", "app")
            .build();
          fasterAnalyticsInstance.event.register(event_faster);
          //End
          //amplitude
          var userId = localStorage.getItem("worker_id");
          amplitude.getInstance().init("acd3720cc16f656e0f48bf417916784d", userId);
          var event = "View_CovidRefund_Home";
          var eventProperties = {
            driver_Id: localStorage.getItem("worker_id"),
            driver_uuid: localStorage.getItem("id"),
            source: "app",
            timestamp: Date.now(),
          };
          amplitude.getInstance().logEvent(event, eventProperties);
        } else {
          const configuration = new FasterConfiguration(
            "c352c9f1-6120-4ef5-87e3-c5cec5eb1cda",
            "oIwfANqzIAItf97FHJulmwvN"
          );
          Faster.configure(configuration);
          const fasterAnalyticsInstance = Faster.start();
          const eventBuilder = new EventBuilder("View_CovidRefund_Empty", 0);
          const event_faster = eventBuilder
            .id(localStorage.getItem("id"))
            .externalId(localStorage.getItem("worker_id"))
            .dimension("driverId", localStorage.getItem("worker_id"))
            .dimension("source", "app")
            .build();
          fasterAnalyticsInstance.event.register(event_faster);
          //End
          //amplitude
          var userId = localStorage.getItem("worker_id");
          amplitude.getInstance().init("acd3720cc16f656e0f48bf417916784d", userId);
          var event = "View_CovidRefund_Empty";
          var eventProperties = {
            driver_Id: localStorage.getItem("worker_id"),
            driver_uuid: localStorage.getItem("id"),
            source: "app",
            timestamp: Date.now(),
          };
          amplitude.getInstance().logEvent(event, eventProperties);
        }
      }
    } catch (error) {
      console.log(error);
      loader.hide();
    }
  },
};
</script>

<style lang="scss" scoped>
hr {
  border-color: transparent;
}
.filter-wrap {
  .col {
    line-height: 1;
    display: flex;
    flex-direction: column;
    &:last-child {
      .filter-btn {
        margin-bottom: 0.5rem;
      }
    }
  }
  .filter-btn {
    display: flex;
    align-items: center;
    justify-items: center;
    text-align: center;
    width: 72px;
    height: 72px;
    border: 1px solid #dcdcdc;
    border-radius: 44px;
    justify-content: center;
    margin: 0 auto 1rem;
    svg {
      fill: $gray-4;
    }
    &.selected {
      svg {
        fill: $red;
      }
      background-color: $light-red;
      border-color: $light-red;
    }
  }
}
</style>
